import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

const ReopenInvoicedJobModal = ({
  jobName,
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} size="small">
    <Modal.Header title={`Reopen ${jobName}?`} />
    <Modal.Body>
      The line items on this job will be removed from its current invoice. To
      bill after edit, generate a new invoice for this job.
    </Modal.Body>
    <Modal.Footer
      confirmBtnText="Reopen"
      confirmBtnLoading={isLoading}
      onSubmit={onConfirm}
      onClose={onClose}
      secondaryBtnText="Cancel"
      secondaryOnSubmit={onClose}
      secondaryBtnVariant="tertiary"
    />
  </Modal>
)

ReopenInvoicedJobModal.propTypes = {
  jobName: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

ReopenInvoicedJobModal.defaultProps = {
  isLoading: false,
}

export default ReopenInvoicedJobModal
